import { Box, Button, Container, Group, Stack, Text, Title, UnstyledButton } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

import { OrnamentalDivider, ScrollIndicator, SideFlourish, SimpleLine } from "@/components/general/decorative-lines/decorative-lines";

import { BackgroundOverlay } from "./components/background-overlay";
import styles from "./hero-section.module.css";

export const HeroSection = () => {
    const { t } = useTranslation();
    const [scroll] = useWindowScroll();
    const scrollOpacity = Math.max(0, 1 - scroll.y / 200);

    return (
        <div className={styles.hero}>
            <Container size="md" className={styles.content}>
                <Stack gap="xl">
                    <Box>
                        <Group align="center" gap="md" mb="xs">
                            <SideFlourish color="white" w={60} />
                            <Text className={styles.supTitle}>{t("home.subTitle")}</Text>
                            <SideFlourish color="white" w={60} flipped />
                        </Group>

                        <Title className={styles.mainTitle} order={1}>
                            ONLINE <span className={styles.highlight}>ESCAPE ROOM</span>
                        </Title>
                        <Title className={styles.mainSub} order={2} c="#c9c9c9">
                            {t("home.title")}
                        </Title>

                        <Group align="center" mt="sm">
                            <SimpleLine width={100} color="white" />
                        </Group>
                    </Box>

                    <Text className={styles.description}>{t("home.intro")}</Text>
                    <Text className={styles.description}>{t("home.intro2")}</Text>

                    <Group pt="md">
                        <Button
                            lts=".06rem"
                            size="xl"
                            radius="xl"
                            onClick={() => {
                                document.querySelector("#demo")?.scrollIntoView({ behavior: "smooth" });
                            }}>
                            {t("home.button")}
                        </Button>
                    </Group>

                    <Box mt={50}>
                        <OrnamentalDivider color="white" className={styles.ornamentalDivider} />
                    </Box>
                </Stack>
            </Container>

            <div className={styles.backgroundImage} />
            <BackgroundOverlay />

            {/* Scroll indicator */}
            <UnstyledButton
                className={styles.scrollIndicator}
                style={{ opacity: scrollOpacity }}
                onClick={() => {
                    // scroll 100vh down
                    const scrollHeight = window.innerHeight;
                    window.scrollBy({ top: scrollHeight, behavior: "smooth" });
                }}
                aria-label="Scroll to next section">
                <ScrollIndicator color="white" />
            </UnstyledButton>
        </div>
    );
};
